import Incentives from "./Incentives";

export default Incentives;
